import { SimpleBars } from '../../../Common/Charts/SimpleBars';
import { useProfileChartsDataContext } from './hooks/useProfileChartsDataContext';

export const CityOfBirth = () => {
    const { chartData } = useProfileChartsDataContext();

    return (
        <SimpleBars
            title={'Nascimento (Top 5)'}
            horizontal={true}
            subtitles={chartData?.cityOfBirth?.map((item) => item.description)}
            values={chartData?.cityOfBirth?.map((item) => item.total  ||  0)}
             className='aligned-container'
        />
    );
};
